import { Box, Divider, Grid } from '@mui/material';
import {
  dateToString,
  getRegistryPatientInformationFields,
  toTitleCase
} from 'common/utils';
import CaseInfoItem from 'components/case/CaseInfoItem/CaseInfoItem';
import CustomText from 'components/common/CustomText/CustomText';
import { useRegistryContext } from 'context/RegistryContext';
import React, { useMemo } from 'react';
import { colors } from 'styles/colors';
import useGlobalStyles from 'styles/globalStyles';

interface Props {
  data: any;
}

export default function RegistryPatientInformationDetails({ data }: Props) {
  const globalStyles = useGlobalStyles();
  const { registry } = useRegistryContext();

  const fields = useMemo(() => {
    if (!registry || !data?.data) return [];

    const registryFields = getRegistryPatientInformationFields(registry.fields);

    return registryFields.map((field) => {
      let value = data.data[field.name];

      // combine patient name
      if (field.name === 'patient_first_name') {
        value = `${data?.data?.patient_last_name}, ${data?.data?.patient_first_name}`;
      }

      // format date values
      if (value && field.name.includes('date')) {
        value = dateToString(new Date(value));
      }

      // dropdown values (like institute)
      if (value && typeof value === 'object' && value.label) {
        value = value.label;
      }

      // normalize strings
      if (typeof value === 'string') {
        value = toTitleCase(value);
      }

      return {
        label: field.property ? toTitleCase(field.property) : field.name,
        value,
      };
    });
  }, [registry, data]);

  return (
    <Box className={globalStyles.sectionContainer}>
      <Box className={globalStyles.sectionHeader}>
        <CustomText
          text="Patient Information"
          color={colors.primary}
          fontWeight={600}
        />
      </Box>

      <Divider />

      <Grid container p={3} spacing={1.5}>
        {fields.map((field, index) => (
          <React.Fragment key={field.label}>
            <Grid size={{ xs: 12, md: 6 }}>
              <CaseInfoItem
                label={field.label}
                value={field.value}
              />
            </Grid>

            {(index % 2 === 1 && index < fields.length - 1) && (
              <Grid size={12}>
                <Divider />
              </Grid>
            )}
          </React.Fragment>
        ))}
      </Grid>
    </Box>
  );
}